import { useEffect, useState } from 'react';
import { subscribeToPushBlockedModal, closePushBlockedModal } from '../../services/pushBlockedModalService';
import { isAndroid, isIOS, isStandalonePWA } from '../../services/platformService';
import { Modal } from '../feedback/Modal';
import { Button } from '../actions/Button';

/**
 * Shown when someone tries to turn push on while the browser/OS permission
 * is `denied`. Browsers never let an app re-ask, so the only path is
 * settings; this says where.
 */
function unblockInstructions(): string {
  if (isIOS() && isStandalonePWA()) {
    return 'Open iPhone Settings → Mission Control → Notifications, and turn on Allow Notifications.';
  }
  if (isAndroid()) {
    return 'Tap the lock icon in the address bar → Site settings → Notifications → Allow.';
  }
  return 'Click the lock icon in the address bar → Site settings, and allow Notifications.';
}

export function PushBlockedModal() {
  const [state, setState] = useState({ isOpen: false });
  useEffect(() => subscribeToPushBlockedModal(setState), []);

  return (
    <Modal
      isOpen={state.isOpen}
      onClose={closePushBlockedModal}
      size="md"
      title="Notifications are blocked"
      footer={
        <Button size="sm" onClick={closePushBlockedModal}>
          Close
        </Button>
      }
    >
      <p className="m-0 text-sm text-muted">{unblockInstructions()}</p>
    </Modal>
  );
}
